
export const getDefaultState = () => {
  return {
    guest: {},
    verified: 0,    
    token: '',
    waitingCode:0,
    codeError:0,
    hasPassword: 0,
    waitingResetCode: 0
  }
}

// initial state
const state = getDefaultState();

export default state;